import { formatDecimalSv } from './numberFormat'
export default {
    mounted(el, { value, modifiers }) {
        const max = Number(Object.keys(modifiers).find(m => m.startsWith('max'))?.slice(3)) || 2
        el.textContent = formatDecimalSv(value, { max })
    },
    updated(el, { value, modifiers }) {
        const max = Number(Object.keys(modifiers).find(m => m.startsWith('max'))?.slice(3)) || 2
        el.textContent = formatDecimalSv(value, { max })
    }
}